'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _defaultProps = require('../default-props');

var _defaultProps2 = _interopRequireDefault(_defaultProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PerspectiveYReverse = function (_React$Component) {
	(0, _inherits3.default)(PerspectiveYReverse, _React$Component);

	function PerspectiveYReverse() {
		(0, _classCallCheck3.default)(this, PerspectiveYReverse);
		return (0, _possibleConstructorReturn3.default)(this, (PerspectiveYReverse.__proto__ || Object.getPrototypeOf(PerspectiveYReverse)).apply(this, arguments));
	}

	(0, _createClass3.default)(PerspectiveYReverse, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    width = _props.width,
			    lineHeight = _props.lineHeight,
			    lineSpacing = _props.lineSpacing;

			var offset = lineHeight + lineSpacing;
			return _react2.default.createElement(
				_base2.default,
				(0, _extends3.default)({ className: 'BurgerPerspectiveYReverse' }, this.props),
				_react2.default.createElement(_style2.default, {
					styleId: '1026865609',
					css: '.BurgerPerspectiveYReverse .BurgerBox{-webkit-perspective:' + width * 2 + 'px;-moz-perspective:' + width * 2 + 'px;-ms-perspective:' + width * 2 + 'px;perspective:' + width * 2 + 'px;}.BurgerPerspectiveYReverse .BurgerInner{-webkit-transition:-webkit-transform 0.15s cubic-bezier(0.645,0.045,0.355,1), background-color 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);-webkit-transition:transform 0.15s cubic-bezier(0.645,0.045,0.355,1), background-color 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);transition:transform 0.15s cubic-bezier(0.645,0.045,0.355,1), background-color 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);}.BurgerPerspectiveYReverse .BurgerInner:before,.BurgerPerspectiveYReverse .BurgerInner:after{-webkit-transition:-webkit-transform 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);-webkit-transition:transform 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);transition:transform 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);}.BurgerPerspectiveYReverse.BurgerActive .BurgerInner{background-color:transparent;-webkit-transform:rotateX(180deg);-ms-transform:rotateX(180deg);transform:rotateX(180deg);}.BurgerPerspectiveYReverse.BurgerActive .BurgerInner:before{-webkit-transform:translate3d(0,' + offset + 'px,0) rotate(45deg);-ms-transform:translate3d(0,' + offset + 'px,0) rotate(45deg);transform:translate3d(0,' + offset + 'px,0) rotate(45deg);}.BurgerPerspectiveYReverse.BurgerActive .BurgerInner:after{-webkit-transform:translate3d(0,' + offset * -1 + 'px,0) rotate(-45deg);-ms-transform:translate3d(0,' + offset * -1 + 'px,0) rotate(-45deg);transform:translate3d(0,' + offset * -1 + 'px,0) rotate(-45deg);}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */\n/*@ sourceURL=../../src/types/perspective-y-reverse.js */',
					dynamic: [width * 2, offset, offset * -1]
				})
			);
		}
	}]);
	return PerspectiveYReverse;
}(_react2.default.Component);

exports.default = PerspectiveYReverse;


PerspectiveYReverse.defaultProps = _defaultProps2.default;
module.exports = exports['default'];
//# sourceMappingURL=perspective-y-reverse.js.map